import "./GetInTouch.module.css";
import Header from "@/reusable_sections/Header";
import RequestATechnicalQuote from "./sections/RequestATechnicalQuote";
import XaritadagiManzilimiz from "./sections/XaritadagiManzilimiz";
import WhyThisIntensive from "./sections/WhyThisIntensive";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Header />
      <RequestATechnicalQuote />
      <XaritadagiManzilimiz />
      <WhyThisIntensive />
      <Footer />
    </div>;
}